// src/components/WebhookModal.js
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { LuWebhook, LuCopy, LuCheck } from 'react-icons/lu';

const WebhookModal = ({ onClose }) => {
    const user = useSelector((state) => state.auth.user);
    // const webhookUrl = user?.webhook_token ? `http://127.0.0.1:8000/api/webhook/${user.webhook_token}` : '';
    const webhookUrl = user?.webhook_token ? `https://tconnserver.astergo.in/api/webhook/${user.webhook_token}` : '';
    const [copied, setCopied] = useState(false);

    // Function to copy the URL to the clipboard
    const handleCopy = () => {
        navigator.clipboard.writeText(webhookUrl).then(() => {
            setCopied(true);
            // Reset the "Copied" message after 2 seconds
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="p-6 space-y-4">
            <div className="flex flex-col items-center text-center">
                <div className="p-3 bg-blue-100 text-blue-500 rounded-full mb-3">
                    <LuWebhook size={28} />
                </div>
                <h2 className="text-xl font-bold text-gray-800">TradingView Webhook URL</h2>
            </div>

            <div className="space-y-1">
                <p className="text-sm font-medium text-gray-600 text-left">Your Personal Webhook URL</p>
                <div className="flex items-center">
                    <input
                        type="text"
                        readOnly
                        value={webhookUrl}
                        className="w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-l-md focus:outline-none"
                    />
                    <button
                        onClick={handleCopy}
                        className="px-3 py-2 bg-blue-600 text-white rounded-r-md hover:bg-blue-700"
                    >
                        {copied ? <LuCheck size={20} /> : <LuCopy size={20} />}
                    </button>
                </div>
            </div>

            <div className="text-left text-sm bg-blue-50 p-3 rounded-lg border border-blue-100">
                <h3 className="font-semibold text-gray-800 mb-2">Instructions:</h3>
                <ol className="list-decimal list-inside space-y-1 text-gray-600">
                    <li>Copy this URL</li>
                    <li>Add it to your TradingView Pine Script strategy</li>
                    <li>Use webhook alerts to send signals</li>
                </ol>
            </div>

            <div className="flex items-center justify-end space-x-3 pt-2">
                <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
                    Close
                </button>
                <button onClick={handleCopy} className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">
                    {copied ? 'Copied!' : 'Copy URL'}
                </button>
            </div>
        </div>
    );
};

export default WebhookModal;